// The formation picker (under the minimap): the party leader, or anyone playing solo, picks how the party lines
// up in battle. Everyone else in the party sees the leader's pick.
import { FORMATIONS, formationDef, type FormationId } from '../../../shared/battle.js';

const $ = <T extends HTMLElement = HTMLElement>(id: string) => document.getElementById(id) as T;

export class FormationUI {
  id: FormationId = 'line';
  size = 1;              // how many would fight together (party members, or you and your companions)
  canPick = true;        // the leader, or solo
  onPick: (id: FormationId) => void = () => {};

  constructor() {
    $('formBtn').addEventListener('click', e => { e.stopPropagation(); this.toggle(); });
    addEventListener('click', e => { if (!(e.target as HTMLElement).closest?.('#formation')) this.toggle(false); });
    addEventListener('keydown', e => { if (e.code === 'Escape') this.toggle(false); });
  }

  setPlaying(on: boolean): void { $('formation').hidden = !on; if (!on) this.toggle(false); }
  set(id: FormationId, size: number, canPick: boolean): void { this.id = id; this.size = size; this.canPick = canPick; this.render(); }

  private toggle(force?: boolean): void { const p = $('formPick'), open = force ?? p.hidden; p.hidden = !open; if (open) this.render(); }

  private render(): void {
    const def = formationDef(this.id);
    $('formBtn').textContent = `⚔ ${def.name}${this.size >= def.min ? '' : ' (Line)'} ▾`;
    $('formBtn').title = 'Battle formation';
    const box = $('formPick'); if (box.hidden) return;
    box.replaceChildren();
    const note = document.createElement('div'); note.className = 'note';
    note.textContent = this.canPick ? `Your party: ${this.size}. Pick how you line up when a battle starts.` : 'Your party leader picks the formation.';
    box.append(note);
    for (const f of FORMATIONS) {
      const b = document.createElement('button'); b.type = 'button'; b.className = f.id === this.id ? 'on' : '';
      b.disabled = !this.canPick;
      const t = document.createElement('b'); t.textContent = `${f.icon}  ${f.name}${f.min > 1 ? `  (${f.min}+)` : ''}`;
      const d = document.createElement('small'); d.textContent = f.desc + ' ' + f.perks.join(' · ') + (this.size < f.min ? `  Needs ${f.min} in the party; until then you fight in a Line.` : '');
      b.append(t, d);
      b.addEventListener('click', () => { this.onPick(f.id); this.toggle(false); });
      box.append(b);
    }
  }
}
